import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";
import { CiLock } from "react-icons/ci";
import HoaNavbar from "../HoaNavbar/HoaNavbar";
import HoaFooter from "../HoaFooter/HoaFooter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { API_URL } from '../../apiConfig';
import LoadingComman from '../Loading/LoadingCommon';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const HoaClientRegister = () => {
  const [contractCode, setContractCode] = useState('');
  const [contractData, setContractData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [addressData, setAddressData] = useState(null);
  const todayDate = new Date().toISOString().split("T")[0];
  const [loadingComman, setLoadingComman] = useState(false);
  const [saveBankDetails, setSaveBankDetails] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);

  console.log("userData", userData);
  console.log("contractData", contractData);
  console.log("addressData", addressData);

  const handleContractCodeChange = (e) => {
    const newContractCode = e.target.value;
    setContractCode(newContractCode);

    // Update formData with the new contract code
    setFormData((prevFormData) => ({
      ...prevFormData,
      contractCode: newContractCode,
    }));
  };

  useEffect(() => {
    if (contractCode) {
      fetchContractData(contractCode);
    }
  }, [contractCode]);

  useEffect(() => {
    if (contractData) {
      if (contractData.userId) {
        fetchUserData(contractData.userId);
      }
      if (contractData.addressId) {
        fetchAddressData(contractData.addressId);
      }
    }
  }, [contractData]);

  const fetchContractData = async (code) => {
    try {
      const response = await fetch(`${API_URL}/public/clientRequest/contractCode/${code}`);
      if (response.ok) {
        const data = await response.json();
        setContractData(data);
      } else {
        console.error('Failed to fetch contract data');
      }
    } catch (error) {
      console.error('Error fetching contract data:', error);
    }
  };

  const fetchUserData = async (userId) => {
    try {
      const response = await fetch(`${API_URL}/user/getById/${userId}`);
      if (response.ok) {
        const data = await response.json();
        const userFormDataUpdate = {
          userDto: {
            activeStatus: data.activeStatus,
            emailId: data.emailId,
            emailIdIsVerified: data.emailIdIsVerified,
            firstName: data.firstName,
            isClient: data.isClient,
            lastLogin: data.lastLogin,
            lastName: data.lastName,
            middleName: data.middleName,
            mobileIsVerified: data.mobileIsVerified,
            mobileNumber: data.mobileNumber,
            otp: data.otp,
            roleId: data.roleId,
            createdDate: data.createdDate,
            modifiedById: data.modifiedById,
            modifiedDate: data.modifiedDate,
            userProfileUrl: data.userProfileUrl,
            userId: data.userId,
            password: data.password,
          }
        };

        setFormData((prevFormData) => ({
          ...prevFormData,
          userDto: userFormDataUpdate.userDto,
        }));
        setUserData(data);
      } else {
        console.error('Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  const fetchAddressData = async (addressId) => {
    try {
      const response = await fetch(`${API_URL}/public/address/getOne/${addressId}`);
      if (response.ok) {
        const data = await response.json();
        console.log("wew", data);

        const addressFormDataUpdate = {
          addressDto: {
            activeStatus: data.activeStatus,
            address: data.address,
            city: data.city,
            addressId: data.addressId,
            countryId: data.countryId,
            stateId: data.stateId,
            zipCode: data.zipCode,
          }
        };
        setSelectedCountryId(data.countryId);
        console.log(data.countryId);
        setFormData((prevFormData) => ({
          ...prevFormData,
          addressDto: addressFormDataUpdate.addressDto,
        }));
        setAddressData(data);
      } else {
        console.error('Failed to fetch address data');
      }
    } catch (error) {
      console.error('Error fetching address data:', error);
    }
  };

  const [formData, setFormData] = useState({
    addressDto: {
      activeStatus: true,
      address: "",
      addressId: 0,
      city: "",
      countryId: 0,
      stateId: 0,
      zipCode: ""
    },
    bankDetailDto: {
      accountHolderName: "",
      bankName: "",
      accountNumber: "",
      bankId: 0,
      communityId: 0,
      createdById: 0,
      createdDate: todayDate,
      isVerified: true,
      modifiedById: null,
      modifiedDate: todayDate,
      routingNumber: ""
    },
    boardMemberRole: "",
    clientDto: {
      activestatus: true,
      clientid: 0,
      communityid: 0,
      displayname: "",
      numberofhouses: 0,
      userid: 0
    },
    communityCode: null,
    contractCode: "",
    userDto: {
      activeStatus: false,
      emailId: "",
      emailIdIsVerified: true,
      firstName: "",
      isClient: true,
      lastLogin: "",
      lastName: "",
      middleName: "",
      mobileIsVerified: true,
      mobileNumber: "",
      otp: 0,
      password: "",
      roleId: 0,
      userId: 0,
      createdDate: "",
      modifiedById: null,
      modifiedDate: "",
      userProfileUrl: null,
    }
  });
  console.log("formData", formData);

  const [errors, setErrors] = useState({});
  const [verified, setVerified] = useState(false);
  const [captchaValid, setCaptchaValid] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [generatedCaptcha, setGeneratedCaptcha] = useState(generateCaptcha());
  const [captchaErrorMessage, setCaptchaErrorMessage] = useState(null);
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState("");
  console.log(stateData);
  useEffect(() => {
    axios.get(`${API_URL}/public/role/getRoles`)
      .then(response => {
        setRoles(response.data);
      })
      .catch(error => {
        console.error('Error fetching roles:', error);
      });

    axios.get(`${API_URL}/public/country/getAll`)
      .then(response => {
        setCountryData(response.data);
      })
      .catch(error => {
        console.error('Error fetching countries:', error);
      });
  }, []);

  useEffect(() => {
    axios.get(`${API_URL}/public/state/getAll`)
      .then(response => {
        setStateData(response.data);
      })
      .catch(error => {
        console.error('Error fetching states:', error);
      });
  }, []);

  useEffect(() => {
    setFormData(prevState => ({
      ...prevState,

      clientDto: {
        ...prevState.clientDto,
        displayname: prevState.userDto.firstName
      }
    }));
  }, [formData.userDto.firstName]);

  function generateCaptcha() {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let captcha = "";
    for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      captcha += characters[randomIndex];
    }
    return captcha;
  }

  function handleInputChange(event) {
    setUserInput(event.target.value);
  }

  function regenerateCaptcha() {
    setGeneratedCaptcha(generateCaptcha());
  }

  const validateForm = async () => {
    let isValid = true;
    const newErrors = {};

    // Validate contractCode
    if (!contractCode?.trim()) {
      newErrors.contractCode = "Please provide your contractCode.";
      isValid = false; // Mark as invalid
    }

    // Validate first name
    if (!formData.userDto.firstName?.trim()) {
      newErrors.firstName = "Please provide your first name.";
      isValid = false; // Mark as invalid
    }

    // Validate last name
    if (!formData.userDto.lastName?.trim()) {
      newErrors.lastName = "Please provide your last name.";
      isValid = false; // Mark as invalid
    }

    // Validate email
    if (!formData.userDto.emailId?.trim()) {
      newErrors.emailId = "Please provide your email address.";
      isValid = false; // Mark as invalid
    } else if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(formData.userDto.emailId)) {
      newErrors.emailId = "Please provide a valid email address (lowercase letters only).";
      isValid = false; // Mark as invalid
    }

    // Validate mobile number
    if (
      !formData.userDto.mobileNumber ||
      formData.userDto.mobileNumber.length < 10 ||
      !/^\d+$/.test(formData.userDto.mobileNumber)
    ) {
      newErrors.mobileNumber = "Please enter a valid phone number.";
      isValid = false; // Mark as invalid
    }

    // Validate address
    if (!formData.addressDto.address || !formData.addressDto.address.trim()) {
      newErrors.address = "Please provide your residential address.";
      isValid = false; // Mark as invalid
    }

    // Validate country
    if (!formData.addressDto.countryId) {
      newErrors.countryId = "Please select a Country.";
      isValid = false; // Mark as invalid
    }

    // Validate state
    if (!formData.addressDto.stateId) {
      newErrors.stateId = "Please select a State.";
      isValid = false; // Mark as invalid
    }

    // Validate city
    if (!formData.addressDto.city?.trim()) {
      newErrors.city = "Please provide your city.";
      isValid = false; // Mark as invalid
    }

    // Validate zip code
    if (!formData.addressDto.zipCode) {
      newErrors.zipCode = "Please provide your zipCode.";
      isValid = false; // Mark as invalid
    }

    // Validate board member role
    if (!formData.boardMemberRole) {
      newErrors.boardMemberRole = "Please select a board member role.";
      isValid = false; // Mark as invalid
    }

    // Validate bank details
    if (!formData.bankDetailDto.routingNumber?.trim()) {
      newErrors.routingNumber = "Routing Number is required.";
      isValid = false; // Mark as invalid
    }

    if (!formData.bankDetailDto.accountHolderName?.trim()) {
      newErrors.accountHolderName = "AccountHolder Name is required.";
      isValid = false; // Mark as invalid
    }

    if (!formData.bankDetailDto.bankName?.trim()) {
      newErrors.bankName = "Bank Name is required.";
      isValid = false; // Mark as invalid
    }

    const accountNumber = formData.bankDetailDto.accountNumber?.trim();
    const confirmAccountNumber = formData.bankDetailDto.confirmAccountNumber?.trim();

    // Validate account number
    if (!accountNumber) {
      newErrors.accountNumber = "Account Number is required.";
      isValid = false; // Mark as invalid
    }

    // Validate confirm account number
    if (!confirmAccountNumber) {
      newErrors.confirmAccountNumber = "Confirm Account Number is required.";
      isValid = false; // Mark as invalid
    } else if (confirmAccountNumber !== accountNumber) {
      newErrors.confirmAccountNumber = "Confirm Account Number must match Account Number.";
      isValid = false; // Mark as invalid
    }

    // Validate captcha
    if (!userInput) {
      newErrors.captcha = "Please fill in the captcha.";
      isValid = false; // Mark as invalid
    } else if (userInput !== generatedCaptcha) {
      newErrors.captcha = "Captcha is incorrect.";
      isValid = false; // Mark as invalid
    }

    // Validate bank details save option
    if (!saveBankDetails) {
      newErrors.saveBankDetails = 'You must save bank details.';
      isValid = false; // Mark as invalid
    }

    // Validate terms acceptance
    if (!acceptTerms) {
      newErrors.acceptTerms = 'You must accept the terms and conditions.';
      isValid = false; // Mark as invalid
    }

    // Set the validation errors to state
    setErrors(newErrors);
    console.log(newErrors);

    // Return true if there are no errors (all validations passed), false otherwise
    return isValid; // This will now correctly indicate if the form is valid
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    if (name === 'addressDto.countryId') {
      setSelectedCountryId(parseInt(value, 10));
    }
    const parsedValue =
      name === 'addressDto.countryId' ||
        name === 'addressDto.stateId' ||
        name === 'userDto.roleId'
        ? parseInt(value)
        : value;

    setFormData(prevState => {
      const updatedState = { ...prevState };
      const nameParts = name.split('.');
      if (nameParts.length === 2) {
        const [parent, child] = nameParts;
        updatedState[parent][child] = parsedValue;
      } else {
        updatedState[name] = parsedValue;
      }
      return updatedState;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingComman(true); // Set loading state to true initially

    // Use await if validateForm becomes an async function
    const isValid = await validateForm();

    if (isValid) {
      try {
        const response = await axios.put(`${API_URL}/public/clientRequest/update-For-First-Client`, formData);
        console.log('Form submitted successfully:', response.data);
        regenerateCaptcha(); // Regenerate captcha upon successful submission
        alert("Registered Successfully");
        window.location.href = '/'; // Redirect after success
      } catch (error) {
        console.error('Error submitting form:', error);
        // You may want to handle errors (like showing an alert)
      } finally {
        setLoadingComman(false); // Reset loading state
      }
    } else {
      // If the form is not valid, simply reset the loading state
      setLoadingComman(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      addressDto: {
        activeStatus: true,
        address: "",
        addressid: 0,
        city: "",
        countryId: 0,
        stateId: 0,
        zipCode: ""
      },
      bankDetailDto: {
        confirmAccountNumber: "",
        accountHolderName: "",
        bankName: "",
        accountNumber: "",
        bankid: 0,
        communityid: 0,
        createdbyid: 0,
        createddate: todayDate,
        isverified: true,
        modifiedbyid: null,
        modifieddate: "",
        routingNumber: " "
      },
      boardMemberRole: "",
      clientDto: {
        activeStatus: true,
        clientid: 0,
        communityid: 0,
        displayname: "",
        numberofhouses: 0,
        userid: 0
      },
      communityCode: null,
      contractCode: "",
      userDto: {
        activeStatus: false,
        emailId: "",
        emailIdIsVerified: true,
        firstName: "",
        isClient: true,
        lastLogin: "",
        lastName: "",
        middleName: "",
        mobileIsVerified: true,
        mobileNumber: "",
        otp: 0,
        password: "",
        roleId: 0,
        userId: 0,
        createdDate: "",
        modifiedById: null,
        modifiedDate: "",
        userProfileUrl: ""
      }
    });
    setErrors({});
    setUserInput("");
    setAcceptTerms(false);
    setSaveBankDetails(false);
  };

  const roleOptions = (roleId) => {
    switch (roleId) {
      case 1001:
        return <option value="admin">HOA Admin</option>;
      case 1002:
        return (
          <>
            <option value="president">President</option>
            <option value="secretary">Secretary</option>
            <option value="treasurer">Treasurer</option>
          </>
        );
      default:
        return null;
    }
  };

  const handleKeyPress = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <>
      <div className="hoa-nav-import">
        <HoaNavbar />
      </div>
      {loadingComman && <LoadingComman />}
      {!loadingComman && (
        <div className="min-h-screen bg-gray-50 py-8">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="bg-blue-800 text-white p-6">
              <h2 className="text-2xl font-bold mb-2">Client Form</h2>
              <p className="text-blue-100">Please enter your info below. * is mandatory</p>
            </div>

            <form onSubmit={handleSubmit} className="p-6">
              {/* Personal Information Section */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                <div className="lg:col-span-3">
                  <label htmlFor="contractCode" className="block text-sm font-medium text-gray-700 mb-2">
                    Contract Code*
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    name="contractCode"
                    id="contractCode"
                    value={contractCode}
                    onChange={handleContractCodeChange}
                  />
                  {errors.contractCode && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.contractCode}</span>
                  )}
                </div>

                <div>
                  <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2">
                    First Name *
                  </label>
                  <input
                    type="text"
                    name="userDto.firstName"
                    id="firstName"
                    placeholder="Please Enter"
                    value={formData.userDto.firstName}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    maxLength={50}
                  />
                  {errors.firstName && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.firstName}</span>
                  )}
                </div>

                <div>
                  <label htmlFor="middleName" className="block text-sm font-medium text-gray-700 mb-2">
                    Middle Name
                  </label>
                  <input
                    type="text"
                    name="userDto.middleName"
                    id="middleName"
                    placeholder="Optional"
                    value={formData.userDto.middleName}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    maxLength={50}
                  />
                </div>

                <div>
                  <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2">
                    Last Name *
                  </label>
                  <input
                    type="text"
                    name="userDto.lastName"
                    id="lastName"
                    placeholder="Please Enter"
                    value={formData.userDto.lastName}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    maxLength={50}
                  />
                  {errors.lastName && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.lastName}</span>
                  )}
                </div>

                <div>
                  <label htmlFor="mobileNumber" className="block text-sm font-medium text-gray-700 mb-2">
                    Phone number *
                  </label>
                  <PhoneInput
                    country={'us'}
                    value={formData.userDto.mobileNumber}
                    onChange={(value) => setFormData({ ...formData, userDto: { ...formData.userDto, mobileNumber: value } })}
                    inputStyle={{
                      width: '100%',
                      height: '38px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px',
                      fontSize: '16px'
                    }}
                    containerStyle={{
                      width: '100%'
                    }}
                  />
                  {errors.mobileNumber && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.mobileNumber}</span>
                  )}
                </div>

                <div>
                  <label htmlFor="emailId" className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="userDto.emailId"
                    id="emailId"
                    placeholder="Email Address"
                    value={formData.userDto.emailId}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    maxLength={100}
                    readOnly
                  />
                  {errors.emailId && <span className="text-red-500 text-sm mt-1 block">{errors.emailId}</span>}
                </div>

                <div>
                  <label htmlFor="roleId" className="block text-sm font-medium text-gray-700 mb-2">
                    Your Role *
                  </label>
                  <select
                    name="userDto.roleId"
                    value={formData.userDto.roleId}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                  >
                    <option value="">Select Role</option>
                    {roles
                      .filter(role => role.name === "Hoa Admin" || role.name === "Hoa Board Member")
                      .map(role => (
                        <option key={role.roleid} value={role.roleid}>{role.name}</option>
                      ))}
                  </select>
                  {errors.roleId && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.roleId}</span>
                  )}
                </div>

                <div>
                  <label htmlFor="boardMemberRole" className="block text-sm font-medium text-gray-700 mb-2">
                    Board Member Role *
                  </label>
                  <select
                    name="boardMemberRole"
                    id="boardMemberRole"
                    value={formData.boardMemberRole}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                  >
                    <option value="">Select Role</option>
                    {roleOptions(formData.userDto.roleId)}
                  </select>
                  {errors.boardMemberRole && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.boardMemberRole}</span>
                  )}
                </div>

                <div className="lg:col-span-3">
                  <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                    Residential Address *
                  </label>
                  <input
                    type="text"
                    name="addressDto.address"
                    id="address"
                    placeholder="Residential Address"
                    value={formData.addressDto.address}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    maxLength={100}
                  />
                  {errors.address && <span className="text-red-500 text-sm mt-1 block">{errors.address}</span>}
                </div>

                <div>
                  <label htmlFor="country" className="block text-sm font-medium text-gray-700 mb-2">
                    Country *
                  </label>
                  <select
                    id='countryId'
                    className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    name="addressDto.countryId"
                    value={formData.addressDto.countryId}
                    onChange={(e) => e.preventDefault()}
                  >
                    <option value="">Filter country</option>
                    {countryData?.map(country => (
                      <option key={country.countryId} value={country.countryid}>{country.countryname}</option>
                    ))}
                  </select>
                  {errors.countryId && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.countryId}</span>
                  )}
                </div>

                <div>
                  <label htmlFor="state" className="block text-sm font-medium text-gray-700 mb-2">
                    State *
                  </label>
                  <select
                    id='stateId'
                    name="addressDto.stateId"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    value={formData.addressDto.stateId}
                    onChange={(e) => e.preventDefault()}
                  >
                    <option value="">Filter State</option>
                    {stateData
                      .filter(state => state.countryid === parseInt(selectedCountryId))
                      .map(state => (
                        <option key={state.stateid} value={state.stateid}>{state.statename}</option>
                      ))}
                  </select>
                  {errors.stateId && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.stateId}</span>
                  )}
                </div>

                <div>
                  <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-2">
                    City *
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    name="addressDto.city"
                    id="City"
                    value={formData.addressDto.city}
                    onChange={handleChange}
                    placeholder="City"
                    maxLength={50}
                    readOnly
                  />
                  {errors.city && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.city}</span>
                  )}
                </div>

                <div>
                  <label htmlFor="zipCode" className="block text-sm font-medium text-gray-700 mb-2">
                    Zip Code *
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    name="addressDto.zipCode"
                    id="zipCode"
                    value={formData.addressDto.zipCode}
                    onChange={handleChange}
                    placeholder="Zip Code"
                    onKeyPress={handleKeyPress}
                    maxLength={10}
                    readOnly
                  />
                  {errors.zipCode && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.zipCode}</span>
                  )}
                </div>
              </div>

              {/* Bank Details Section */}
              <div className="bg-blue-800 text-white p-4 rounded-t-lg mb-6">
                <h2 className="text-xl font-bold mb-2 flex items-center">
                  <CiLock className="mr-2" /> Add Bank Details
                </h2>
                <p className="text-blue-100">Bank account details</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div>
                  <label htmlFor="accountHolderName" className="block text-sm font-medium text-gray-700 mb-2">
                    Account Holder Name *
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    name="bankDetailDto.accountHolderName"
                    id="accountHolderName"
                    value={formData.bankDetailDto.accountHolderName}
                    onChange={handleChange}
                    maxLength={50}
                  />
                  {errors.accountHolderName && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.accountHolderName}</span>
                  )}
                </div>

                <div>
                  <label htmlFor="bankName" className="block text-sm font-medium text-gray-700 mb-2">
                    Bank Name *
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    name="bankDetailDto.bankName"
                    id="bankName"
                    value={formData.bankDetailDto.bankName}
                    onChange={handleChange}
                    maxLength={50}
                  />
                  {errors.bankName && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.bankName}</span>
                  )}
                </div>

                <div>
                  <label htmlFor="routingNumber" className="block text-sm font-medium text-gray-700 mb-2">
                    Routing Number *
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    name="bankDetailDto.routingNumber"
                    id="routingNumber"
                    value={formData.bankDetailDto.routingNumber}
                    onChange={handleChange}
                    maxLength={50}
                  />
                  {errors.routingNumber && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.routingNumber}</span>
                  )}
                </div>

                <div>
                  <label htmlFor="accountNumber" className="block text-sm font-medium text-gray-700 mb-2">
                    Account Number *
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    name="bankDetailDto.accountNumber"
                    id="accountNumber"
                    value={formData.bankDetailDto.accountNumber}
                    onChange={handleChange}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength="50"
                  />
                  {errors.accountNumber && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.accountNumber}</span>
                  )}
                </div>

                <div className="md:col-span-2">
                  <label htmlFor="confirmAccountNumber" className="block text-sm font-medium text-gray-700 mb-2">
                    Confirm Account Number *
                  </label>
                  <input
                    type="password"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                    name="bankDetailDto.confirmAccountNumber"
                    id="confirmAccountNumber"
                    value={formData.bankDetailDto.confirmAccountNumber}
                    onChange={handleChange}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength="50"
                  />
                  {errors.confirmAccountNumber && (
                    <span className="text-red-500 text-sm mt-1 block">{errors.confirmAccountNumber}</span>
                  )}
                </div>
              </div>

              {/* Checkboxes and Terms */}
              <div className="space-y-4 mb-6">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    className="hidden"
                    id="saveBankDetails"
                    checked={saveBankDetails}
                    onChange={() => setSaveBankDetails(!saveBankDetails)}
                  />
                  <label
                    htmlFor="saveBankDetails"
                    className="flex items-center cursor-pointer"
                  >
                    <div className={`w-5 h-5 border-2 rounded mr-3 flex items-center justify-center ${saveBankDetails ? 'bg-blue-800 border-blue-800' : 'border-gray-300'}`}>
                      {saveBankDetails && (
                        <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      )}
                    </div>
                    <Link to="" className="text-blue-800 hover:text-blue-600">Save bank details</Link>
                  </label>
                </div>
                {errors.saveBankDetails && <span className="text-red-500 text-sm block ml-8">{errors.saveBankDetails}</span>}

                <div className="flex items-center">
                  <input
                    type="checkbox"
                    className="hidden"
                    id="acceptTerms"
                    checked={acceptTerms}
                    onChange={() => setAcceptTerms(!acceptTerms)}
                  />
                  <label
                    htmlFor="acceptTerms"
                    className="flex items-center cursor-pointer"
                  >
                    <div className={`w-5 h-5 border-2 rounded mr-3 flex items-center justify-center ${acceptTerms ? 'bg-blue-800 border-blue-800' : 'border-gray-300'}`}>
                      {acceptTerms && (
                        <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      )}
                    </div>
                    <Link to="" className="text-blue-800 hover:text-blue-600">
                      Terms of Use, Privacy Policy, Terms & Conditions
                    </Link>
                  </label>
                </div>
                {errors.acceptTerms && <span className="text-red-500 text-sm block ml-8">{errors.acceptTerms}</span>}
              </div>

              {/* Captcha Section */}
              <div className="bg-gray-50 p-6 rounded-lg mb-6">
                <div className="flex flex-col lg:flex-row items-center gap-4">
                  <div className="flex items-center gap-4">
                    <div className="bg-gradient-to-r from-gray-200 to-gray-300 p-4 rounded-md">
                      <p className="text-xl font-bold text-gray-700 tracking-wider font-mono">
                        {generatedCaptcha}
                      </p>
                    </div>

                    <button
                      type="button"
                      onClick={regenerateCaptcha}
                      className="p-3 bg-blue-800 text-white rounded-md hover:bg-blue-700 transition-colors"
                    >
                      <FontAwesomeIcon icon={faSync} />
                    </button>
                  </div>

                  <div className="flex-1">
                    <input
                      type="text"
                      value={userInput}
                      onChange={handleInputChange}
                      placeholder="Enter Captcha"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-transparent"
                      maxLength={6}
                    />
                    {errors.captcha && (
                      <span className="text-red-500 text-sm mt-1 block">{errors.captcha}</span>
                    )}
                  </div>
                </div>
              </div>

              {/* Submit Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-end">
                <button
                  className="px-6 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
                  type="button"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-6 py-3 bg-blue-800 text-white rounded-md hover:bg-blue-700 transition-colors font-medium"
                >
                  Confirm
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <div className="hoa-footer-import">
        <HoaFooter />
      </div>
    </>
  );
};

export default HoaClientRegister;